import { COLORS } from "@app/constants";
import { useWindowDimensions } from "@app/hooks";
import BigNumber from "bignumber.js";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";
import { useTimezone } from "../../../../../hooks/timezone";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";

const OverviewRightTableList = ({ data }) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <View
      style={{
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
        paddingBlock: isMobile? 15 : 8,
        paddingInline: 5,
      }}
    >
      <View style={{ alignItems: "flex-start" }}>
        <Text size={16} style={{ marginBottom: 3, fontWeight: "400" }}>
          {t(data?.detail)}
        </Text>
        <Text size={14} style={{ color: COLORS.lightGray, fontWeight: "300" }}>
          {useTimezone(data?.sentAt, "YYYY-MM-DD HH:mm:ss", -9)}
        </Text>
      </View>
      <View style={{ alignItems: "flex-end" }}>
        <Text
          size={width < 1200 ? 14 : 15}
          style={{
            marginBottom: isMobile ? MobileCalVW(8) : 3,

            fontWeight: "500",
          }}
        >
          {data?.type == "D" ? "+" : "-"}
          {BigNumber(data?.amount || 0)?.toFormat(4)} USDT
        </Text>
        <Text size={12} style={{ fontWeight: "400", color: COLORS.lightGray }}>
          {t(data?.detail)}
          {/*{data?.confirm_amount*/}
          {/*  ? `${data?.type == "W" ? t("withdraw") : t('deposit')}`*/}
          {/*  : `${data?.type == "W" ? t("withdraw") : t('deposit')}`}{" "}*/}
          {/* {data?.process == 1 ? t('subscription') : data?.process == 2 ? t('complete') : t('rejected')} */}
          {/*{t('complete')}*/}
        </Text>
      </View>
    </View>
  );
};

export default React.memo(OverviewRightTableList);
